import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  OutlinedInput,
} from "@mui/material";
import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next"; // 🆕
import { useTipos } from "../hooks/useTiposAsignatura";
import { useAsignarFormador } from "../hooks/useAsignarFormador";
import { useTiposAsignados } from "../hooks/useTiposAsignados";
import toast from "react-hot-toast";

type Props = {
  open: boolean;
  onClose: () => void;
  userId: number;
};

export default function AsignarFormadorDialog({ open, onClose, userId }: Props) {
  const { t } = useTranslation<"translation">(); // 🆕
  const { rows: tipos } = useTipos();
  const { mutateAsync, isPending } = useAsignarFormador();
  const { data: tiposAsignados, isSuccess } = useTiposAsignados(userId, open);

  const [selectedTipos, setSelectedTipos] = useState<number[]>([]);

  useEffect(() => {
    if (open && isSuccess) {
      setSelectedTipos(tiposAsignados ?? []);
    }
  }, [open, isSuccess, tiposAsignados]);

  const handleAsignar = async () => {
    try {
      await mutateAsync({ userId, tipoIds: selectedTipos });
      toast.success(t("asignarFormador.toast.success"));
      onClose();
      setSelectedTipos([]);
    } catch (err: any) {
      toast.error(err?.response?.data?.message || t("asignarFormador.toast.error"));
    }
  };

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("asignarFormador.title")}</DialogTitle>

      <DialogContent>
        <FormControl fullWidth margin="normal">
          <InputLabel>{t("asignarFormador.subjectTypes")}</InputLabel>

          <Select
            multiple
            value={selectedTipos}
            onChange={(e) => setSelectedTipos(e.target.value as number[])}
            input={<OutlinedInput label={t("asignarFormador.subjectTypes")} />}
            renderValue={(selected) =>
              tipos
                .filter((t) => selected.includes(t.id))
                .map((t) => t.nombre)
                .join(", ")
            }
          >
            {tipos.map((t) => (
              <MenuItem key={t.id} value={t.id}>
                <Checkbox checked={selectedTipos.includes(t.id)} />
                <ListItemText primary={t.nombre} />
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={isPending}>
          {t("common.cancel")}
        </Button>
        <Button variant="contained" onClick={handleAsignar} disabled={isPending}>
          {isPending ? t("asignarFormador.assigning") : t("asignarFormador.assign")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
